/** The only cross-app sign-in continuation we accept is a canonical catalog record. */
export function catalogReturnTarget(value: string | null | undefined): string | null {
  const match = value?.match(/^(\/admin\/catalog\/[a-f0-9]{24})(?:\?([^#]*))?$/);
  if (!match) return null;
  const supplied = new URLSearchParams(match[2] ?? '');
  const retained = new URLSearchParams();
  const section = supplied.get('section');
  if (section && ['overview', 'engineering', 'documents', 'inventory', 'history'].includes(section)) retained.set('section', section);
  if (supplied.get('edit') === '1') retained.set('edit', '1');
  const query = retained.toString();
  return match[1] + (query ? '?' + query : '');
}
